/**
 * Jotai atoms for resolved feature-flag state.
 */

import { atom } from 'jotai';
import type { ResolvedFlag } from '../api/feature-flags';

/** key -> resolved flag, refreshed on login and kept live via WebSocket. */
export const featureFlagsAtom = atom<Map<string, ResolvedFlag>>(new Map());
export const featureFlagsLoadedAtom = atom<boolean>(false);
